"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalNumberErrors = exports.BirthPlace = exports.PersonalNumberType = exports.Gender = void 0;
var Gender;
(function (Gender) {
    Gender["Male"] = "MALE";
    Gender["Female"] = "FEMALE";
})(Gender = exports.Gender || (exports.Gender = {}));
var PersonalNumberType;
(function (PersonalNumberType) {
    PersonalNumberType["PersonalNumber"] = "PERSONNUMMER";
    PersonalNumberType["CoordinationNumber"] = "SAMORDNINGSNUMMER";
    PersonalNumberType["IndividualCompany"] = "ENSKILD_FIRMA";
})(PersonalNumberType = exports.PersonalNumberType || (exports.PersonalNumberType = {}));
var BirthPlace;
(function (BirthPlace) {
    BirthPlace["Stockholm"] = "Stockholms l\u00E4n";
    BirthPlace["Uppsala"] = "Uppsala l\u00E4n";
    BirthPlace["Sodermansland"] = "S\u00F6dermanlands l\u00E4n";
    BirthPlace["Ostergotland"] = "\u00D6sterg\u00F6tlands l\u00E4n";
    BirthPlace["Jonkoping"] = "J\u00F6nk\u00F6pings l\u00E4n";
    BirthPlace["Kronoberg"] = "Kronobergs l\u00E4n";
    BirthPlace["Kalmar"] = "Kalmar l\u00E4n";
    BirthPlace["Gotland"] = "Gotlands l\u00E4n";
    BirthPlace["Blekinge"] = "Blekinge l\u00E4n";
    BirthPlace["Kristianstad"] = "Kristianstads l\u00E4n";
    BirthPlace["Malmohus"] = "Malm\u00F6hus l\u00E4n";
    BirthPlace["Halland"] = "Hallands l\u00E4n";
    BirthPlace["GoteborgBohus"] = "G\u00F6teborgs och bohus l\u00E4n";
    BirthPlace["Alvsborg"] = "\u00C4lvsborgs l\u00E4n";
    BirthPlace["Skaraborg"] = "Skaraborgs l\u00E4n";
    BirthPlace["Varmland"] = "V\u00E4rmlands l\u00E4n";
    BirthPlace["Extranummer"] = "Extranummer";
    BirthPlace["Orebro"] = "\u00D6rebro l\u00E4n";
    BirthPlace["Vastmanland"] = "V\u00E4stmanlands l\u00E4n";
    BirthPlace["Kopparberg"] = "Kopparbergs l\u00E4n";
    BirthPlace["Gavleborg"] = "G\u00E4vleborgs l\u00E4n";
    BirthPlace["Vasternorrland"] = "V\u00E4sternorrlands l\u00E4n";
    BirthPlace["Jamtland"] = "J\u00E4mtlands l\u00E4n";
    BirthPlace["Vasterbotten"] = "V\u00E4sterbottens l\u00E4n";
    BirthPlace["Norrbotten"] = "Norrbottens l\u00E4n";
    BirthPlace["ExtranummerImmigrerad"] = "Extranummer (immigrerade)";
})(BirthPlace = exports.BirthPlace || (exports.BirthPlace = {}));
var PersonalNumberErrors;
(function (PersonalNumberErrors) {
    PersonalNumberErrors["InputType"] = "INPUT_TYPE";
    PersonalNumberErrors["Format"] = "FORMAT";
    PersonalNumberErrors["Checksum"] = "CHECKSUM";
    PersonalNumberErrors["IncorrectDate"] = "INCORRECT_DATE";
    PersonalNumberErrors["AgeSeparatorContradiction"] = "AGE_SEPARATOR_CONTRADICTION";
    PersonalNumberErrors["BackToTheFuture"] = "BACK_TO_THE_FUTURE";
})(PersonalNumberErrors = exports.PersonalNumberErrors || (exports.PersonalNumberErrors = {}));
